export default __webpack_public_path__ + "static/media/dai.433ecf60.svg";